import { ChatSourceMapperService } from '../../services/chat/mapping/chat-source-mapper.service';

type RagChunks = Parameters<ChatSourceMapperService['mapRagChunks']>[0];

export interface ChatConversationMetadata {
  relevant_chunks?: RagChunks;
  selected_chunk?: { metadata?: { id?: string | null } | null } | null;
  selected_chunk_id?: string | null;
  expert_role?: string | null;
}

export function formatChatError(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message?: unknown }).message || error);
  }
  return String(error);
}
